import React from 'react';
import { Modal as UIModalBase } from '@makemydeal/ui-bricks/dist/cox';
import type { ModalProps } from './ModalProps';
import { StyledModal, Description, Heading } from './Modal.style';

// cox's published ModalProps require `modalHeader: string` and `handleOpenClose` and omit
// `children`, but at runtime the component renders a ReactNode header and children (and only
// uses `handleOpenClose` when a close button is shown). Re-type it to the contract we use.
const UIModal = UIModalBase as unknown as React.FC<{
    modalHeader?: React.ReactNode;
    children?: React.ReactNode;
}>;

const Modal: React.FC<ModalProps> = ({ title = '', description = '', children, className = '' }) => {
    return (
        <StyledModal className={`sales-checkin-modal-wrapper ${className}`}>
            <UIModal
                modalHeader={
                    <>
                        <Heading className="modal-title">{title}</Heading>
                        {description && <Description className="modal-description">{description}</Description>}
                    </>
                }
            >
                {children}
            </UIModal>
        </StyledModal>
    );
};

export default Modal;
